module.exports = __webpack_public_path__ + "media/images/tl/banner/zh-light-pc-2aed8f05b7b057b43c1990408c08c44a.jpg";